import { Button } from "@/components/ui/Button"
import { Spinner } from "@/components/ui/Spinner"

interface SummaryStepProps {
  summary: string
  isLoading: boolean
  isSubmitting?: boolean
  onConfirm: () => void
  onBack: () => void
}

export function SummaryStep({
  summary,
  isLoading,
  isSubmitting = false,
  onConfirm,
  onBack,
}: SummaryStepProps) {
  return (
    <div className="tw-text-center tw-space-y-8">
      <h2 className="tw-text-3xl tw-font-bold tw-text-gray-800">
        Assignment Preview
      </h2>

      <div className="tw-max-w-3xl tw-mx-auto tw-bg-white tw-rounded-xl tw-shadow-sm tw-p-8 tw-border tw-border-gray-200">
        {isLoading ? (
          <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-py-8">
            <Spinner className="tw-w-8 tw-h-8" />
            <p className="tw-text-gray-600">
              Generating your assignment preview...
            </p>
          </div>
        ) : (
          <div className="tw-text-left tw-space-y-4">
            <div className="tw-prose tw-prose-sm tw-max-w-none">
              <div className="tw-whitespace-pre-wrap tw-text-gray-700 tw-leading-relaxed">
                {summary}
              </div>
            </div>
          </div>
        )}
      </div>

      {!isLoading && summary && (
        <div className="tw-flex tw-justify-center tw-gap-4 tw-pt-4">
          <Button
            type="button"
            onClick={onBack}
            variant="outline"
            size="lg"
            className="tw-min-w-[120px]"
            disabled={isSubmitting}
          >
            No, Go Back
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            size="lg"
            className="tw-min-w-[120px] tw-bg-primary hover:tw-bg-green-600"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span className="tw-flex tw-items-center tw-gap-2">
                <Spinner className="tw-w-4 tw-h-4" />
                Creating...
              </span>
            ) : (
              "Yes, Create It"
            )}
          </Button>
        </div>
      )}
    </div>
  )
}
